import { compose, lifecycle, withHandlers, withState, withProps } from "recompose";
import LoginWithFacebook from "../libs/loginWithFacebook";
import LoginWithInstagram from "../libs/loginWithInstagram";
import CreateSourceWithFacebookAccount from "../libs/createSourceWithFacebookAccount";
import { setToken } from "../libs/authorization";
import { path } from "ramda";
import { INSTAGRAM_LOGIN_URL } from "../../../constants";

const getUsername = path(["data", "createSourceWithFacebookAccount", "sources", 0, "name"]);

export const withFacebookAccountsModal = compose(
  withState("facebookAccountLoading", "updateFacebookAccountLoading", false),
  withState("facebookAccount", "selectFacebookAccount", null),
  withState("error", "updateError", null),
  withHandlers({
    onClickContinue: props => () => {
      if (props.facebookAccount) {
        props.onRequestClose(true);
        props.setLoading(true);
        props.updateError(null);
        CreateSourceWithFacebookAccount({ accountId: props.facebookAccount })
          .then(res => {
            props.setLoading(false);
            window.location.href = `/best-2020/${getUsername(res)}`;
          })
          .catch(error => props.updateError(error));
      }
    },
  })
);

export const withFacebookLogin = compose(
  withState("facebookLoginStatus", "updateFacebookLoginStatus", false),
  withState("loading", "setLoading", false),
  withState("error", "updateError", null),
  withHandlers({
    onClickLoginWithFacebook: props => () => {
      props.setLoading(true);
      window.FB.login(
        response => {
          if (response.status !== "connected") {
            props.updateError("Invalid Facebook Login,  please try again.");
          } else if (response.authResponse) {
            const { userID, accessToken } = response.authResponse;
            localStorage.setItem("token", "");
            LoginWithFacebook({ userFacebookId: userID, accessToken }).then(user => {
              if (user) {
                setToken(user.token);
                if (user.facebookPages && user.facebookPages.length > 1) {
                  props.updateFacebookPages(user.facebookPages);
                  props.updateShowFacebookAccountsModal(true);
                } else {
                  CreateSourceWithFacebookAccount({ accountId: user.facebookPages[0].id })
                    .then(res => {
                      props.setLoading(false);
                      window.location.href = `/best-2020/${getUsername(res)}`;
                    })
                    .catch(error => props.updateError(error));
                }
                props.onRequestClose();
              } else {
                props.updateError("Sorry, an unexpected error has ocurred, please try again.");
              }
            });
          }
        },
        { scope: "manage_pages,pages_show_list" }
      );
    },
  }),
  lifecycle({
    componentDidMount() {
      if (window.FB) {
        window.FB.getLoginStatus(function(response) {
          if (response && response.status == "connected") {
            // this.props.updateFacebookLoginStatus(true);
          }
        });
      }
    },
  })
);

export const withInstagramLogin = compose(
  withHandlers({
    onClickLoginWithInstagram: props => ({ email, handleNextStep, handlePrevStep }) => {
      let newWin;
      if (handleNextStep) {
        handleNextStep();
      }
      window.addEventListener(
        "message",
        msg => {
          if (msg.data.type != "top-nine-web/oauth/instagram") {
            return;
          }

          try {
            const genericError = "Invalid Instagram Login, please try again.";
            const payload = msg.data.payload;
            if (payload && payload.code) {
              newWin && newWin.close();
              LoginWithInstagram({ loginCode: payload.code, email }).then(user => {
                if (user) {
                  setToken(user.token);
                  window.location.href = `/edit-top-nine`;
                } else {
                  props.updateError(genericError);
                  if (handlePrevStep) {
                    handlePrevStep();
                  }
                }
              });
            } else {
              if (handlePrevStep) {
                handlePrevStep();
              }
              props.updateError(genericError);
            }
          } catch (error) {
            console.log("[withInstagramLogin] Error", { error });
          }
        },
        false
      );
      newWin = window.open(INSTAGRAM_LOGIN_URL, "_blank");
    },
  })
);

export const withSteps = compose(
  withState("step", "setStep", 0),
  withHandlers({
    handlePrevStep: ({ step, setStep }) => () => setStep(step - 1 < 0 ? 0 : step - 1),
    handleNextStep: ({ step, maxStep, setStep }) => () => setStep(step + 1 > maxStep ? 0 : step + 1),
  })
);

export const withAuthenticatedLogin = compose(
  withState("error", "updateError", null),
  withProps({
    maxStep: 2,
  }),
  withSteps,
  // withFacebookLogin,
  withInstagramLogin,
  withHandlers({
    onClickGetTopNine: props => () => props.handleNextStep(),
    onClickAutomaticTopNine: props => () => props.updateShowFacebookInfoModal(true),
    onClickManualTopNine: props => ({ email, handleNextStep }) =>
      props.onClickLoginWithInstagram({ email, handleNextStep }),
  })
);
